import React from 'react';
import PropTypes from 'prop-types';
import SectionContainer from '../SectionContainer';
import { IndexSection, SectionHeader, Heading } from "./styles";

const IndexPageSection = ({ heading, headerAdditional, hasRelativePosition, children, id }) => (
  <IndexSection style={{ position: hasRelativePosition ? 'relative' : 'static' }} id={id}>
    <SectionContainer>
      <SectionHeader>
        <Heading>{heading}</Heading>
        {headerAdditional}
      </SectionHeader>
      {children}
    </SectionContainer>
  </IndexSection>
);

IndexPageSection.propTypes = {
  heading: PropTypes.node.isRequired,
  headerAdditional: PropTypes.node,
  hasRelativePosition: PropTypes.bool,
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
};

export default IndexPageSection;
